import { TierPeriod } from '../entities';
export const selectFamilyPlanPrices = (state) => state.stripe.familyPlanPrices?.[TierPeriod.monthly];
